import JwtService from './jwt.service'
import ApiService from './api.service'
import { SET_AUTH_CLIENT, OPEN_LOGIN_DIALOG } from '@/store/mutations.type'

// Saves the JWT/refresh-token pair carried in a member-session-issuing response
// (POST /member/create, POST /member/identity-verification/verify), then fetches and commits
// the real member profile via GET /member/selfInfo. Returns a Promise, since the selfInfo fetch
// is async - callers must await this before navigating or the router guard can purge the session
// mid-flow. GET /member/selfInfo is permitted for every session flag, including the quarantine/
// terms jails - it's strictly self-scoped, so a member reading their own profile poses no
// cross-member disclosure risk regardless of verification/terms-acceptance state.
export const applySessionFromResponse = (store, response) => {
  const apiToken = response.headers['api-token']
  const refreshToken = response.headers['api-refresh-token']
  // A missing header must never be written to the token cookie - JS coerces undefined to the
  // literal string "undefined" on cookie serialization, corrupting the Authorization header on
  // every subsequent request until manually cleared. Throw immediately instead.
  if (!apiToken || !refreshToken) {
    throw new Error('applySessionFromResponse: response is missing api-token/api-refresh-token headers')
  }
  JwtService.saveToken(apiToken)
  JwtService.saveRefreshToken(refreshToken)
  ApiService.setHeader()

  return ApiService.get('/member/selfInfo').then(selfInfoResponse => {
    store.commit(SET_AUTH_CLIENT, selfInfoResponse.data)
    // SET_AUTH_CLIENT has a side effect of reopening the login dialog - close it back down here
    // rather than relying on the caller to do so afterward.
    store.commit(OPEN_LOGIN_DIALOG, false)
  })
}
